(function () {
  'use strict';
  var CFG = window.HWA_FD_STEPPER;
  if (!CFG) return;
  var MAX = 0;
  var state = null;

  function q(sel) { return document.querySelector(sel); }
  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text != null) e.textContent = text;
    return e;
  }

  // 画面に出す名前。選択肢の末尾の容量表記（例：「 8キューブ/120g (1袋)」）は省く。カートに送る値は変えない。
  function disp(label) {
    var t = label.replace(/\s+\d.*$/, '').trim();
    return t || label;
  }

  // アプリのselect（properties[1]、[2]…）を連番で集める
  function findSelects() {
    var out = [];
    for (var n = 1; n < 30; n++) {
      var s = q('select[name="properties[' + n + ']"]');
      if (!s) break;
      out.push(s);
    }
    return out.length >= 2 ? out : null;
  }

  function optionValue(select, label) {
    for (var i = 0; i < select.options.length; i++) {
      if (select.options[i].text.trim() === label) return select.options[i].value;
    }
    return null;
  }

  // 設定（CFG.flavors）が無い商品は、全selectに共通する選択肢を味一覧として使う
  function flavorList(selects) {
    if (CFG.flavors && CFG.flavors.length) return CFG.flavors.map(function (f) { return { label: f.label, age: f.age, image: f.image }; });
    var base = [].map.call(selects[0].options, function (o) { return o.text.trim(); }).filter(function (l) { return l !== ''; });
    var common = base.filter(function (l) {
      return selects.every(function (s) { return optionValue(s, l) !== null; });
    });
    if (!common.length) return null;
    var ord = CFG.order ? CFG.order.split(',') : [];
    common.sort(function (a, b) {
      var ia = ord.indexOf(a), ib = ord.indexOf(b);
      if (ia < 0) ia = 999;
      if (ib < 0) ib = 999;
      return (ia - ib) || a.localeCompare(b, 'ja');
    });
    return common.map(function (l) { return { label: l }; });
  }

  function total() {
    return state.flavors.reduce(function (a, f) { return a + f.count; }, 0);
  }

  function expanded() {
    var list = [];
    state.flavors.forEach(function (f) {
      for (var i = 0; i < f.count; i++) list.push(f);
    });
    return list;
  }

  function fire(node) {
    ['input', 'change'].forEach(function (t) {
      node.dispatchEvent(new Event(t, { bubbles: true }));
    });
  }

  // stepperの内容を、既存アプリのselect（properties[1]〜[N]）へ反映する。N袋そろったときだけ。
  function syncSelects() {
    if (total() !== MAX) return;
    var list = expanded();
    for (var i = 0; i < MAX; i++) {
      var v = list[i].values[i];
      if (state.selects[i].value !== v) state.selects[i].value = v;
      fire(state.selects[i]);
    }
  }

  function render(announce) {
    var t = total();
    var rem = MAX - t;
    state.flavors.forEach(function (f) {
      f.numEl.textContent = String(f.count);
      f.rowEl.classList.toggle('is-on', f.count > 0);
      f.minus.disabled = f.count <= 0;
      f.plus.disabled = t >= MAX;
    });
    state.countNum.textContent = String(t);
    state.barFill.style.width = (t / MAX * 100) + '%';
    state.sumMain.textContent = rem > 0 ? 'あと' + rem + '袋選んでください' : MAX + '袋そろいました';
    var picked = state.flavors.filter(function (f) { return f.count > 0; }).map(function (f) { return disp(f.label) + ' ×' + f.count; });
    state.sumDetail.textContent = picked.length ? '選択中：' + picked.join('、') : '';
    if (announce) {
      state.live.textContent = '合計' + t + '袋、' + (rem > 0 ? 'あと' + rem + '袋' : 'そろいました');
    }
    state.err.hidden = true;
    syncSelects();
  }

  function change(f, delta) {
    var t = total();
    if (delta > 0 && t >= MAX) return;
    if (delta < 0 && f.count <= 0) return;
    f.count += delta;
    render(true);
  }

  // メインの購入フォームID（分割払い案内用の別フォームは除外）
  function isMainFormId(id) {
    id = id || '';
    return id.indexOf('product-form') === 0 && !/payment-installment$/.test(id);
  }

  function isMainForm(form) {
    if (!form || !form.getAttribute) return false;
    return isMainFormId(form.getAttribute('id')) && !!form.querySelector('[name="id"]');
  }

  function guard(e) {
    if (!state) return;
    if (total() === MAX) { syncSelects(); return; }
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    var rem = MAX - total();
    state.err.textContent = 'あと' + rem + '袋、味を選んでください。';
    state.err.hidden = false;
    state.root.scrollIntoView({ block: 'center', behavior: 'smooth' });
    var first = state.flavors.filter(function (f) { return !f.plus.disabled; })[0];
    if (first) first.plus.focus({ preventScroll: true });
  }

  function installGuard() {
    document.addEventListener('submit', function (e) {
      if (isMainForm(e.target)) guard(e);
    }, true);
    document.addEventListener('click', function (e) {
      var b = e.target && e.target.closest ? e.target.closest('button') : null;
      if (!b || b.type === 'button' || b.type === 'reset') return;
      if (b.closest('.hwa-fd')) return;
      // テーマの<buy-buttons form="...">のボタン（button自身にform属性がない）も対象
      var bb = b.closest('buy-buttons');
      if (bb && isMainFormId(bb.getAttribute('form'))) { guard(e); return; }
      if (isMainForm(b.form)) guard(e);
    }, true);
  }

  function build(selects) {
    MAX = selects.length;
    var list0 = flavorList(selects);
    if (!list0) return false;
    var flavors = list0.map(function (f) {
      f.count = 0;
      f.values = selects.map(function (s) { return optionValue(s, f.label); });
      return f;
    });
    // 既存selectの選択肢と一致しない場合は何も変えない（既存UIを残す）
    for (var i = 0; i < flavors.length; i++) {
      for (var j = 0; j < flavors[i].values.length; j++) if (flavors[i].values[j] === null) return false;
    }
    var appBlock = selects[0].closest('.product-info__block-item');
    if (!appBlock || !appBlock.parentNode) return false;

    var root = el('div', 'product-info__block-item hwa-fd');
    root.setAttribute('role', 'group');
    root.setAttribute('aria-labelledby', 'hwa-fd-title');

    // 「送料無料」チップは価格ブロックのすぐ下へ。価格ブロックが見つからないときだけここに残す
    var priceBlock = q('.product-info__block-item[data-block-type="price"]');
    var shipUnderPrice = !!(CFG.ship && priceBlock && priceBlock.parentNode);

    var chipDefs = [];
    if (CFG.first) chipDefs.push(['初回限定', '']);
    if (CFG.same) chipDefs.push(['同じ味も選べます', '']);
    if (CFG.ship && !shipUnderPrice) chipDefs.push(['送料無料', ' hwa-fd__chip--ship']);
    if (chipDefs.length) {
      var chips = el('ul', 'hwa-fd__chips');
      chipDefs.forEach(function (c) {
        chips.appendChild(el('li', 'hwa-fd__chip' + c[1], c[0]));
      });
      root.appendChild(chips);
    }

    if (shipUnderPrice) {
      var ship = el('div', 'product-info__block-item hwa-fd-ship');
      ship.appendChild(el('span', 'hwa-fd__chip hwa-fd__chip--ship', '送料無料'));
      priceBlock.parentNode.insertBefore(ship, priceBlock.nextSibling);
    }

    var head = el('div', 'hwa-fd__head');
    var title = el('h2', 'hwa-fd__title', '好きな味を、' + MAX + '袋。');
    title.id = 'hwa-fd-title';
    var count = el('div', 'hwa-fd__count');
    var countNum = el('strong', null, '0');
    count.appendChild(countNum);
    count.appendChild(document.createTextNode(' / ' + MAX + '袋'));
    head.appendChild(title);
    head.appendChild(count);
    root.appendChild(head);

    root.appendChild(el('p', 'hwa-fd__lead', CFG.same
      ? '＋で1袋ずつ追加。同じ味を' + MAX + '袋でもOKです。'
      : '＋で1袋ずつ追加して、' + MAX + '袋にしてください。'));
    if (CFG.spec) root.appendChild(el('p', 'hwa-fd__spec', CFG.spec));
    var bar = el('div', 'hwa-fd__bar');
    bar.setAttribute('aria-hidden', 'true');
    var barFill = el('span', 'hwa-fd__bar-fill');
    bar.appendChild(barFill);
    root.appendChild(bar);

    var list = el('ul', 'hwa-fd__list');
    flavors.forEach(function (f) {
      var li = el('li', 'hwa-fd__row' + (f.image ? '' : ' hwa-fd__row--noimg'));
      if (f.image) {
        var img = el('img', 'hwa-fd__img');
        img.src = f.image; img.alt = ''; img.width = 48; img.height = 48; img.loading = 'lazy';
        li.appendChild(img);
      }
      var info = el('div', 'hwa-fd__info');
      info.appendChild(el('span', 'hwa-fd__name', disp(f.label)));
      if (f.age) info.appendChild(el('span', 'hwa-fd__age', f.age));
      li.appendChild(info);
      var step = el('div', 'hwa-fd__step');
      var minus = el('button', 'hwa-fd__btn', '−');
      minus.type = 'button';
      minus.setAttribute('aria-label', disp(f.label) + 'を1袋減らす');
      var num = el('span', 'hwa-fd__num', '0');
      num.setAttribute('aria-hidden', 'true');
      var plus = el('button', 'hwa-fd__btn', '+');
      plus.type = 'button';
      plus.setAttribute('aria-label', disp(f.label) + 'を1袋増やす');
      step.appendChild(minus); step.appendChild(num); step.appendChild(plus);
      li.appendChild(step);
      list.appendChild(li);
      f.rowEl = li; f.numEl = num; f.minus = minus; f.plus = plus;
      minus.addEventListener('click', function () { change(f, -1); });
      plus.addEventListener('click', function () { change(f, 1); });
    });
    root.appendChild(list);

    if (CFG.note) root.appendChild(el('p', 'hwa-fd__note', CFG.note));

    var sum = el('div', 'hwa-fd__sum');
    var sumMainRow = el('div', 'hwa-fd__sum-main');
    var sumMain = el('span', null, '');
    var price = el('span', 'hwa-fd__sum-price', CFG.price || '');
    price.appendChild(el('small', null, '税込'));
    sumMainRow.appendChild(sumMain);
    sumMainRow.appendChild(price);
    sum.appendChild(sumMainRow);
    var sumDetail = el('p', 'hwa-fd__sum-detail', '');
    sum.appendChild(sumDetail);
    var err = el('p', 'hwa-fd__err', '');
    err.setAttribute('role', 'alert');
    err.hidden = true;
    sum.appendChild(err);
    root.appendChild(sum);

    var live = el('div', 'hwa-fd__sr');
    live.setAttribute('role', 'status');
    live.setAttribute('aria-live', 'polite');
    root.appendChild(live);

    appBlock.parentNode.insertBefore(root, appBlock);
    appBlock.classList.add('hwa-fd-app-hidden');
    appBlock.setAttribute('aria-hidden', 'true');
    if ('inert' in appBlock) appBlock.inert = true;

    state = {
      flavors: flavors, selects: selects, root: root, countNum: countNum, barFill: barFill,
      sumMain: sumMain, sumDetail: sumDetail, err: err, live: live
    };
    render(false);
    return true;
  }

  var done = false;
  function tryInit() {
    if (done) return;
    var selects = findSelects();
    if (!selects) return;
    done = true;
    try {
      if (build(selects)) installGuard();
    } catch (err) {
      if (window.console) console.warn('hwa-fd-stepper: fallback to original selects', err);
    }
  }

  tryInit();
  if (!done) {
    document.addEventListener('DOMContentLoaded', tryInit);
    var obs = new MutationObserver(tryInit);
    obs.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { obs.disconnect(); }, 10000);
  }
})();
